import { GraphQLClient as o } from "graphql-request";
const n = "https://api.cs.seeen.com/graphql/";
function r(e, t) {
  const a = new o(e, { headers: t });
  return {
    request(c, i) {
      return a.request(c, i);
    },
    apiUrl: e
  };
}
function s({
  apiKey: e,
  apiUrl: t = n
}) {
  return r(t, { "x-api-key": e });
}
function l({
  token: e,
  apiUrl: t = n
}) {
  return r(t, { Authorization: `Bearer ${e}` });
}
const p = s;
export {
  s as a,
  l as b,
  p as c
};
